const comments = [
  {
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20young%20Chinese%20woman%20with%20warm%20smile%2C%20clean%20natural%20lighting%20on%20soft%20neutral%20background%2C%20friendly%20approachable%20look%2C%20editorial%20portrait%20photography&width=120&height=120&seq=avatar-01&orientation=squarish',
    name: '吃瓜不嫌事大',
    time: '2分钟前',
    content: '台北娜娜这次的新视频太劲爆了！细节满满，感觉整个娱乐圈都要震动，不愧是一线话题人物。',
    likes: 2341,
    tag: '台北娜娜',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Portrait%20headshot%20of%20a%20young%20Chinese%20man%20with%20confident%20expression%2C%20clean%20studio%20lighting%20on%20neutral%20gray%20background%2C%20modern%20professional%20portrait%20photography&width=120&height=120&seq=avatar-02&orientation=squarish',
    name: '八卦研究员',
    time: '15分钟前',
    content: '莫里秀合集看得我停不下来，每一期都有新料，51吃瓜的整理太到位了，必须点赞支持！',
    likes: 1856,
    tag: '莫里秀',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Headshot%20portrait%20of%20a%20young%20Asian%20woman%20with%20warm%20expression%2C%20soft%20natural%20light%20on%20cream%20background%2C%20friendly%20editorial%20portrait%20style&width=120&height=120&seq=avatar-03&orientation=squarish',
    name: '深夜吃瓜人',
    time: '28分钟前',
    content: '玩偶姐姐最新动态终于更新了！等了好久终于等到今天，这一波料太足了，不愧是我关注的宝藏博主。',
    likes: 3120,
    tag: '玩偶姐姐',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20young%20Chinese%20professional%20with%20genuine%20smile%2C%20clean%20bright%20studio%20lighting%2C%20neutral%20white%20background%2C%20modern%20corporate%20portrait&width=120&height=120&seq=avatar-04&orientation=squarish',
    name: '娱乐圈观察家',
    time: '42分钟前',
    content: '51吃瓜app真的是我每天必刷的平台，台北娜娜的每条动态都第一时间跟进，资讯速度全网最快。',
    likes: 987,
    tag: '51吃瓜app',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20stylish%20young%20Asian%20woman%20looking%20directly%20at%20camera%2C%20soft%20flattering%20light%2C%20warm%20neutral%20background%2C%20editorial%20fashion%20portrait&width=120&height=120&seq=avatar-05&orientation=squarish',
    name: '瓜田里的守望者',
    time: '1小时前',
    content: '每天打开51吃瓜就能看到莫里秀和玩偶姐姐的新瓜，太方便了。爆料速度和质量都是一流的。',
    likes: 1567,
    tag: '莫里秀',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            吃瓜热评
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            百万吃瓜群众实时热议，看看大家都在聊什么
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {comments.map((item, i) => (
            <div
              key={i}
              className="bg-background-100 rounded-xl p-4 md:p-5 transition-all duration-200 hover:bg-background-200/70"
            >
              <div className="flex items-start gap-3 mb-3">
                <img
                  src={item.avatar}
                  alt={item.name}
                  className="w-10 h-10 rounded-full object-cover flex-shrink-0"
                />
                <div className="min-w-0 flex-1">
                  <div className="flex items-center gap-2 flex-wrap">
                    <span className="font-medium text-sm text-foreground-900">
                      {item.name}
                    </span>
                    <span className="px-2 py-0.5 text-[11px] rounded-full bg-accent-100 text-accent-700 font-medium">
                      {item.tag}
                    </span>
                  </div>
                  <span className="text-xs text-foreground-400">{item.time}</span>
                </div>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed mb-3">
                {item.content}
              </p>
              <div className="flex items-center gap-3 text-xs text-foreground-400">
                <span className="flex items-center gap-1 cursor-pointer hover:text-primary-500 transition-colors">
                  <span className="w-3.5 h-3.5 flex items-center justify-center">
                    <i className="ri-thumb-up-line"></i>
                  </span>
                  {item.likes.toLocaleString()}
                </span>
                <span className="flex items-center gap-1 cursor-pointer hover:text-primary-500 transition-colors">
                  <span className="w-3.5 h-3.5 flex items-center justify-center">
                    <i className="ri-chat-1-line"></i>
                  </span>
                  回复
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}